"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffPlatformSharing = exports.getShareIconLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const device_detection_1 = require("../../device-detection");
const offPlatformShareEnums_1 = require("../../offPlatformShareEnums");
const sharingUtils_1 = require("../../sharingUtils");
const OffPlatformSharing_module_css_1 = __importDefault(require("./OffPlatformSharing.module.css"));
const event_1 = require("@snapchat/ts-protos/event");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_env_1 = require("@snapchat/web-env");
const getShareIconLabel = (destinationId) => {
    switch (destinationId) {
        case offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.COPY_LINK: {
            return "Copy Link";
        }
        case offPlatformShareEnums_1.OffPlatformShareDestinationPlatform.MORE: {
            return "More Sharing Options";
        }
        default: {
            return "Share on " + destinationId;
        }
    }
};
exports.getShareIconLabel = getShareIconLabel;
/**
 *
 */
function OffPlatformSharing({ url, pageName, pageType, shareDestinations, incrementCounter, children = null, }) {
    const webClientId = (0, web_sc_cookies_1.useGetWebClientId)() ?? "";
    const emitSuccessMetrics = (pageType, pageName, clickedMedia, shareSheetDestinations, webShareUrl) => {
        void incrementCounter(`${pageName}.Desktop.Share.${clickedMedia.id}.Success`);
        (0, web_blizzard_reporting_1.reportWebPageShare)({
            sessionTimeSec: 0,
            shareSource: event_1.WebShareSource.WEB_SHARE_BAR,
            webDestinationsAvailable: shareSheetDestinations.join(","),
            webDestinationsSeen: shareSheetDestinations.join(","),
            destinationSelected: clickedMedia.shareDestination,
            shareStatus: event_1.WebShareStatus.WEB_SHARE_STATUS_SUCCESS,
            deepLinkUrl: webShareUrl,
            // eslint-disable-next-line no-restricted-globals
            webPageUrl: window.location.href,
            pageType,
            webClientId,
        });
    };
    const handleClick = (shareDestinations, clickedMedia, url, pageName, pageType) => () => {
        const shareSheetDestinations = shareDestinations.map((shareDestination) => shareDestination.shareDestination.toString());
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!(0, web_env_1.getWindow)() || !url || !clickedMedia.shareBaseUrl) {
            void incrementCounter(`${pageName}.Desktop.Share.Failure`);
            (0, web_blizzard_reporting_1.reportWebPageShare)({
                sessionTimeSec: 0,
                shareSource: event_1.WebShareSource.WEB_SHARE_BAR,
                webDestinationsAvailable: shareSheetDestinations.join(","),
                webDestinationsSeen: shareSheetDestinations.join(","),
                destinationSelected: clickedMedia.shareDestination,
                shareStatus: event_1.WebShareStatus.WEB_SHARE_STATUS_FAILED,
                pageType,
                webClientId,
            });
            return;
        }
        const webShareUrl = (0, sharingUtils_1.prepareUrlForSharing)(url, device_detection_1.DeviceType.DESKTOP, clickedMedia.id);
        const platformShareUrl = `${clickedMedia.shareBaseUrl}${webShareUrl}`;
        emitSuccessMetrics(pageType, pageName, clickedMedia, shareSheetDestinations, webShareUrl);
        (0, web_env_1.getWindow)()?.open(platformShareUrl, "_blank");
    };
    const renderShareDestinations = (shareDestinations, url, pageName, pageType) => shareDestinations.map((dsd) => ((0, jsx_runtime_1.jsx)("div", { className: OffPlatformSharing_module_css_1.default.icon, "data-testid": "offPlatformIcon", children: (0, jsx_runtime_1.jsx)(web_core_ui_1.IconButton, { onClick: handleClick(shareDestinations, dsd, url, pageName, pageType), size: "XSMALL", label: (0, exports.getShareIconLabel)(dsd.id), children: (0, jsx_runtime_1.jsx)("div", { className: OffPlatformSharing_module_css_1.default.iconWrapper, children: (0, jsx_runtime_1.jsx)(dsd.icon, {}) }) }) }, dsd.id)));
    return ((0, jsx_runtime_1.jsxs)("div", { className: OffPlatformSharing_module_css_1.default.container, "data-testid": "offPlatformSharingContainer", children: [children, renderShareDestinations(shareDestinations, url, pageName, pageType)] }));
}
exports.OffPlatformSharing = OffPlatformSharing;
//# sourceMappingURL=OffPlatformSharing.js.map